import { createStyle } from 'game/lib/createStyles';
import { colors, fonts } from 'game/styles/theme';

export const TentIntSprite = (
  <>
    <rect width="520" height="370" y="320" fill="#235d85" rx="21.82" />
    <path
      fill="#b3b3b3"
      d="M280 0h-40C96.41 0 0 116.41 0 260v38.18A21.82 21.82 0 0021.82 320h476.36A21.82 21.82 0 00520 298.18V260C520 116.41 423.59 0 280 0z"
    />
    <path
      fill="#e6e6e6"
      stroke="gray"
      strokeWidth="3"
      d="M230 110h60a100 100 0 01100 100v0h0-260 0v0a100 100 0 01100-100z"
    />
    <path
      fill="none"
      stroke="gray"
      strokeLinecap="round"
      strokeWidth="3"
      d="M10 210L510 210"
    />
    <path
      fill="#9e0b0b"
      d="M185.25 352.38l-9.25-7.94a16.8 16.8 0 01-5.14-18.12L181 296.06a5.1 5.1 0 014.89-3.42h7.22v3.09h-7.22a2.06 2.06 0 00-2 1.31l-10.1 30.26a13.7 13.7 0 004.21 14.79l9.25 7.94zM221.33 352.38l-2-2.35 9.26-7.94a13.71 13.71 0 004.22-14.79L222.63 297a2.06 2.06 0 00-2-1.31h-7.22v-3.09h7.22a5.1 5.1 0 014.89 3.42l10.16 30.26a16.8 16.8 0 01-5.14 18.12z"
    />
    <path
      fill="#045568"
      d="M205.2 298.07h-7.68a3.86 3.86 0 013.86 3.86 3.86 3.86 0 01-3.86 3.86h7.68a3.85 3.85 0 003.86-3.86 3.86 3.86 0 00-3.86-3.86z"
    />
    <path
      fill="#1293c6"
      d="M204.2 285.72h-4.37a2.55 2.55 0 012.55 2.55v9.78h4.37v-9.78a2.55 2.55 0 00-2.55-2.55z"
    />
    <rect
      width="37.11"
      height="7.72"
      x="184.94"
      y="298.07"
      fill="#d13b3b"
      rx="3.86"
    />
    <path
      fill="#ea5050"
      d="M192.92 285.72h21.85a2.55 2.55 0 012.55 2.55v9.78h-26.95v-9.78a2.55 2.55 0 012.55-2.55zM212 285.72h-17.52a5.72 5.72 0 015.72-5.72h6.11a5.72 5.72 0 015.72 5.72z"
    />
    <path
      fill="#d13b3b"
      d="M194.7 284.14a5.85 5.85 0 00-.22 1.58H212a5.85 5.85 0 00-.22-1.58z"
    />
    <path
      fill="#f1f7fc"
      d="M215.93 337q8.65-15.6-.34-31.22H191q-9 15.62-.34 31.22z"
    />
    <path
      fill="#dcedf9"
      d="M215.59 305.78h-4.78A18.57 18.57 0 01188 330.86a35.47 35.47 0 002.72 6.14h25.24q8.62-15.6-.37-31.22z"
    />
    <path
      fill="#d13b3b"
      d="M221.66 345.85l-5.77-3.33h-25.2l-5.77 3.33a7.05 7.05 0 00-3.54 6.11v7a3.32 3.32 0 003.33 3.32h37.16a3.32 3.32 0 003.33-3.28v-7a7.05 7.05 0 00-3.54-6.15z"
    />
    <path
      fill="#9e0b0b"
      d="M210 337L190.69 337 190.69 340.55 190.69 342.52 210 342.52 215.93 342.52 215.93 340.55 215.93 337 210 337z"
    />
    <path
      fill="#326b33"
      d="M369.52 373.13a4.5 4.5 0 01-3.74-7c1.08-1.62 4.36-6.55-7.84-26.53-15-24.52-19-70.22-19.16-72.15a4.51 4.51 0 119-.76c0 .45 4 45.51 17.87 68.21 13.4 21.93 11.38 30.62 7.65 36.23a4.51 4.51 0 01-3.76 2z"
    />
    <path
      fill="#1a1a1a"
      d="M343.94 382.44c10.56 2.24 21.2-4.15 27.45-12.17 1.64-2.1-3.67-3.89-5.14-2-3.83 4.9-8.9 8.87-15.07 10.22a18.32 18.32 0 01-4.93.46h-.82c-.85-.06.54.07-.17 0l-.62-.1c-1-.22-2.86 0-3.11 1.29s1.37 2.14 2.41 2.36z"
    />
    <path
      fill="#326b33"
      d="M246.68 366.26a4.74 4.74 0 002.62-.14c2.19-.81 2.81-3.26 1.39-5.45-1.11-1.7-4.47-6.81 8.42-23.39 15.53-22.39 19.65-67.88 19.81-69.83a4 4 0 00-4.11-4.4 5.19 5.19 0 00-4.89 4.56c0 .44-4.27 44.11-18.71 64.43-14.21 17.8-12.26 25.82-8.44 31.58a6.35 6.35 0 003.91 2.64z"
    />
    <path
      fill="#1a1a1a"
      d="M273.49 381.14c-11.13-.54-22.27-9.16-28.73-17.88-1.69-2.23 3.9-2.76 5.41-.73a39.24 39.24 0 0015.72 13 24.42 24.42 0 005.18 1.63l.86.15c.9.15-.57-.06.18 0a4.62 4.62 0 00.65.05c1.09 0 3 .67 3.27 2s-1.44 1.78-2.54 1.74zM312 289.23h-8.82a11.4 11.4 0 01-11.38-11.38v-16.47A11.39 11.39 0 01303.14 250H312a11.39 11.39 0 0111.38 11.38v16.47A11.39 11.39 0 01312 289.23zm-8.82-35.85a8 8 0 00-8 8v16.47a8 8 0 008 8H312a8 8 0 008-8v-16.47a8 8 0 00-8-8z"
    />
    <path
      fill="#4c4441"
      d="M272.28 264.18h69.5a3.76 3.76 0 013.76 3.76v112.37a3.76 3.76 0 01-3.76 3.76h-69.5a3.75 3.75 0 01-3.75-3.75V267.94a3.76 3.76 0 013.75-3.76z"
    />
    <path
      fill="#3b7a3b"
      d="M272.28 264.18a3.76 3.76 0 00-3.76 3.76V369h11.65a3.75 3.75 0 003.75-3.76v-101zM333.88 369a3.75 3.75 0 01-3.75-3.76v-101h11.65a3.75 3.75 0 013.75 3.76v101z"
    />
    <path
      fill="#ce0505"
      d="M367.45 282.78c0 3.11-3.17 5.63-7.08 5.63H254.74c-3.91 0-7.08-2.52-7.08-5.63V272.2c0-3.11 3.17-5.63 7.08-5.63h105.63c3.91 0 7.08 2.52 7.08 5.63z"
    />
    <path
      fill="red"
      d="M367.45 277c0 1.31-3.17 2.37-7.08 2.37H254.74c-3.91 0-7.08-1.06-7.08-2.37v-4.47c0-1.31 3.17-2.37 7.08-2.37h105.63c3.91 0 7.08 1.06 7.08 2.37z"
    />
    <path
      fill="#665f5d"
      d="M348 295.53a3.75 3.75 0 01-3.75 3.76h-74.49a3.75 3.75 0 01-3.75-3.76V264c0-2.07 1.68-2.25 3.75-2.25h74.53c2.07 0 3.75.18 3.75 2.25z"
    />
    <path fill="#3a8c3a" d="M279.13 337.5H335.97V377.97H279.13z" />
    <rect
      width="56.96"
      height="22.83"
      x="278.94"
      y="334.9"
      fill="#665f5d"
      rx="3.46"
    />
    <path fill="#262626" d="M303.53 295.01H310.7V329.23H303.53z" />
    <rect width="12.25" height="16.66" x="300.99" y="300.24" rx="2.3" />
    <rect
      width="7.64"
      height="8.5"
      x="303.29"
      y="305.64"
      fill="#262626"
      rx="1.44"
    />
    <path
      fill="#262626"
      d="M285.53 355.73H290.05999999999995V375.83000000000004H285.53z"
    />
    <rect width="7.74" height="10.53" x="283.92" y="358.63" rx="1.45" />
    <rect
      width="4.83"
      height="5.37"
      x="285.38"
      y="362.05"
      fill="#262626"
      rx="0.91"
    />
    <path
      fill="#262626"
      d="M323.99 355.73H328.52V375.83000000000004H323.99z"
    />
    <path d="M323.84 358.63h4.83a1.46 1.46 0 011.46 1.46v7.62a1.45 1.45 0 01-1.45 1.45h-4.83a1.46 1.46 0 01-1.46-1.46v-7.62a1.45 1.45 0 011.45-1.45z" />
    <rect
      width="4.83"
      height="5.37"
      x="323.84"
      y="362.05"
      fill="#262626"
      rx="0.91"
    />
    <path d="M370 332.99H510V412.99H370z" opacity="0.2" />
    <path
      fill="none"
      stroke="#a15d3a"
      strokeLinecap="round"
      strokeWidth="7"
      d="M380 360L380 410"
    />
    <path
      fill="none"
      stroke="#a15d3a"
      strokeLinecap="round"
      strokeWidth="7"
      d="M500 360L500 410"
    />
    <path fill="#a15d3a" d="M370 280H510V360H370z" />
    <path fill="#61321e" d="M370 360H510V370H370z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="3"
      d="M390 280L390 370"
      opacity="0.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="3"
      d="M410 280L410 370"
      opacity="0.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="3"
      d="M430 280L430 370"
      opacity="0.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="3"
      d="M450 280L450 370"
      opacity="0.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="3"
      d="M470 280L470 370"
      opacity="0.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="3"
      d="M490 280L490 370"
      opacity="0.3"
    />
    <path
      d="M10 510h150v33a15.58 15.58 0 01-15.58 15.58H25.58A15.58 15.58 0 0110 543v-33z"
      opacity="0.2"
    />
  </>
);

export const CotSprite = (
  <>
    <path
      fill="none"
      stroke="#b3b3b3"
      strokeWidth="10"
      d="M15 41h130a10 10 0 0110 10v210h0H5h0V51a10 10 0 0110-10zM5 261h150v33a15.58 15.58 0 01-15.58 15.58H20.58A15.58 15.58 0 015 294v-33h0z"
    />
    <path
      fill="#b21924"
      d="M134.69 42.52c0 19.78-24.49 24.25-54.69 24.25S25.31 62.3 25.31 42.52 49.8 6.7 80 6.7s54.69 16.03 54.69 35.82z"
    />
    <path
      fill="#c1272d"
      d="M133.53 35.18c-7-11.37-26.14-19.54-48.68-19.54-28.46 0-51.54 13-51.54 29.05s23.08 19.67 51.54 19.67c15.9 0 30.11-1.13 39.56-4.93 6.46-3.7 10.28-9.11 10.28-16.91a23.92 23.92 0 00-1.16-7.34z"
    />
    <path
      fill="#f7931e"
      stroke="#cc6e11"
      strokeWidth="2"
      d="M155 45.43C155 40.9 131.54 1 80 1S5 40.9 5 45.43v25.82a7.05 7.05 0 002.52 5.24A7.09 7.09 0 005 81.74v25.82a7.05 7.05 0 002.52 5.24A7.08 7.08 0 005 118.05v25.81a7.06 7.06 0 002.52 5.25A7.06 7.06 0 005 154.36v25.81a7.06 7.06 0 002.52 5.25A7.06 7.06 0 005 190.67v25.81a7.09 7.09 0 002.52 5.25A7.05 7.05 0 005 227v25.82c0 4.5 4.88 8.18 10.89 8.18h128.22c6 0 10.89-3.68 10.89-8.21V227a7.05 7.05 0 00-2.52-5.24 7.09 7.09 0 002.52-5.25v-25.84a7.06 7.06 0 00-2.52-5.25 7.06 7.06 0 002.52-5.25v-25.81a7.06 7.06 0 00-2.52-5.25 7.06 7.06 0 002.52-5.25v-25.81a7.08 7.08 0 00-2.52-5.25 7.05 7.05 0 002.52-5.24V81.74a7.09 7.09 0 00-2.52-5.25 7.05 7.05 0 002.52-5.24zM80 65.8c-29.23 0-52.92-4.32-52.92-23.47S50.77 7.66 80 7.66s52.92 15.53 52.92 34.67S109.23 65.8 80 65.8z"
    />
    <path
      fill="#cc6e11"
      d="M78.25 82c-39 0-63.5-4.28-63.86-4.35s-.77-.44-.65-.79a.91.91 0 011-.49c.55.09 55.22 9.67 132 0a.86.86 0 011 .54c.08.36-.24.7-.71.76A551.76 551.76 0 0178.25 82zM78.25 118.35c-39 0-63.5-4.29-63.86-4.35s-.77-.44-.65-.8a.92.92 0 011-.49c.55.1 55.22 9.67 132 0a.87.87 0 011 .55c.08.36-.24.7-.71.76a553.68 553.68 0 01-68.85 4.34zM78.25 154.71c-39 0-63.5-4.29-63.86-4.36s-.77-.44-.65-.79a.91.91 0 011-.49c.55.1 55.22 9.67 132 0a.87.87 0 011 .54c.08.36-.24.7-.71.76a551.94 551.94 0 01-68.85 4.35zM78.25 191.06c-39 0-63.5-4.28-63.86-4.35s-.77-.44-.65-.8a.92.92 0 011-.49c.55.1 55.22 9.68 132 0a.86.86 0 011 .54c.08.36-.24.7-.71.76a551.76 551.76 0 01-68.85 4.34zM78.25 227.42c-39 0-63.5-4.29-63.86-4.35s-.77-.44-.65-.8a.92.92 0 011-.49c.55.1 55.22 9.67 132 0a.88.88 0 011 .54c.08.36-.24.71-.71.77a553.68 553.68 0 01-68.85 4.34z"
    />
    <path d="M80 258.83c-.9 0-1.64-.54-1.64-1.21V69.08c0-.66.74-1.21 1.64-1.21s1.63.55 1.63 1.21v188.54c0 .67-.73 1.21-1.63 1.21z" />
  </>
);

export const FranklinSprite = (
  <>
    <circle cx="49.27" cy="42.66" r="42.66" fill="#0071bc" />
    <circle
      cx="49.27"
      cy="42.66"
      r="42.66"
      fill="#29abe2"
      opacity="0.5"
    />
    <circle cx="48.02" cy="41.41" r="39.86" fill="#0071bc" />
    <circle
      cx="43.48"
      cy="26.45"
      r="22.01"
      fill="#29abe2"
      opacity="0.2"
    />
    <circle
      cx="53.14"
      cy="28.24"
      r="10.67"
      fill="#dcedf9"
    />
    <path
      fill="#0b0b0b"
      d="M53.14 15.72a12.52 12.52 0 1012.53 12.52 12.52 12.52 0 00-12.53-12.52zm0 23.19a10.67 10.67 0 1110.68-10.67 10.67 10.67 0 01-10.68 10.67z"
    />
    <path
      fill="#0b0b0b"
      d="M63.62 36.27a2.64 2.64 0 102.64 2.64 2.64 2.64 0 00-2.64-2.64zm0 4.89a2.25 2.25 0 112.25-2.25 2.25 2.25 0 01-2.25 2.25z"
    />
    <path d="M63.41 41.43H63.989999999999995V49.57H63.41z" />
    <path
      fill="#f1f7fc"
      d="M49.07 38.1a10.47 10.47 0 002.38.66l9-18.28a10.6 10.6 0 00-2-1.47z"
    />
    <path
      fill="none"
      d="M55.62 38.61a10.64 10.64 0 007.26-14.73zM53.14 17.57a10.67 10.67 0 000 21.34h.58l8.22-16.71a10.66 10.66 0 00-8.8-4.63z"
    />
    <path
      fill="#f1f7fc"
      d="M61.94 22.2l-8.22 16.68a9.89 9.89 0 001.9-.27l7.26-14.73a11.48 11.48 0 00-.94-1.68z"
    />
    <path
      fill="#1b1464"
      d="M49.27 1.54a41.09 41.09 0 0141.12 41.12 41.14 41.14 0 01-57.12 37.89 41.09 41.09 0 01-13.07-67 41.06 41.06 0 0129.07-12m0-1.54a42.67 42.67 0 1042.67 42.65A42.66 42.66 0 0049.27 0z"
    />
    <path d="M67.6 47.2c-.19.16-.4.31-.63.47a9.22 9.22 0 01-4.61 1.39c-5.8.29-10.91-9.69-19-9.28-2.08.1-5 .6-8.86 4.47-3.89-3.88-6.76-4.37-8.85-4.47-8.14-.41-13.24 9.57-19 9.28A9.18 9.18 0 012 47.67c-.22-.16-.43-.31-.63-.47C-.54 46 .07 48.21.19 48.65 1.9 53.89 6.28 62.3 17 62.83c8.54.44 14.43-3.47 17.44-7.79 3 4.31 8.9 8.21 17.44 7.79C62.64 62.3 67 53.89 68.73 48.65c.14-.44.74-2.65-1.13-1.45z" />
    <path
      fill="none"
      d="M21.78 22.46l-.67-9.76c-.31.29-.61.59-.91.89a40.38 40.38 0 00-3.62 4.13l4 5.07-2.82.8-2.73-3.74c-.35.53-.68 1.06-1 1.6l.23 3.14-2.26.64c-.22.47-.43.95-.64 1.43a41.17 41.17 0 0021.91 53.89 41.1 41.1 0 0057.12-37.89A41.12 41.12 0 0033.27 4.78a39.49 39.49 0 00-5.11 2.59l.09 1.56-2.59.74v-.65c-.69.49-1.37 1-2 1.54l.76 11.17zM32.9 9.17l.1 1.39a4.14 4.14 0 012.83-2.49q2.77-.79 3.47 1.73a2.38 2.38 0 01.07.38c0 .16 0 .32.05.49s0 .32 0 .47v.35l.4 5.82-2.5.69-.42-5.81c0-.16 0-.36-.06-.61a3.53 3.53 0 00-.1-.58.86.86 0 00-.59-.58 1.45 1.45 0 00-.92 0 2.25 2.25 0 00-.95.52 2.44 2.44 0 00-.6.8 3.48 3.48 0 00-.29 1 5.33 5.33 0 000 1l.37 5.28-2.56.73-.72-9.92zm-4.53 1.29l.63 9.93-2.57.73-.69-9.92z"
    />
    <path
      fill="#fff"
      d="M14 21.45a40.22 40.22 0 00-2 3.78l2.25-.64zM20.6 22.79l-4-5.07q-.79 1-1.53 2.13l2.73 3.74zM21.78 22.46l2.56-.73-.76-11.17c-.85.68-1.67 1.39-2.47 2.14zM28.25 8.93l-.09-1.56c-.87.52-1.71 1.07-2.54 1.65v.65z"
    />
    <path
      fill="#fff"
      d="M29.04 20.39L28.37 10.46 25.78 11.2 26.47 21.12 29.04 20.39z"
    />
    <path
      fill="#fff"
      d="M33.72 19.06l-.37-5.28a5.33 5.33 0 010-1 3.48 3.48 0 01.29-1 2.44 2.44 0 01.6-.8 2.25 2.25 0 01.95-.52 1.45 1.45 0 01.92 0 .86.86 0 01.59.58 3.53 3.53 0 01.1.58c0 .25 0 .45.06.61l.46 5.77 2.57-.73-.4-5.82v-.35-.47c0-.16 0-.33-.05-.49a2.38 2.38 0 00-.07-.38q-.7-2.52-3.45-1.74A4.14 4.14 0 0033 10.55l-.1-1.38-2.46.7.72 9.92z"
    />
    <path
      fill="#1b1464"
      d="M15.05 19.85l-1 1.52v.08c.33-.54.66-1.07 1-1.6z"
    />
  </>
);

export const FranklinShadowSprite = (
  <ellipse cx="25" cy="8.5" rx="25" ry="8.5" opacity="0.2" />
);

export const TentFlapInnerSprite = (
  <path
    fill="#1d1d1b"
    d="M172.19 183.89H2.72V86.61A83.89 83.89 0 0186.61 2.72h1.69a83.89 83.89 0 0183.89 83.89z"
    opacity="0.5"
  />
);

export const TentFlapOuterSprite = (
  <path
    fill="#f9b233"
    d="M88.3 0h-1.69A86.7 86.7 0 000 86.61v100h174.91v-100A86.7 86.7 0 0088.3 0zm83.89 183.89H2.72V86.61A83.89 83.89 0 0186.61 2.72h1.69a83.89 83.89 0 0183.89 83.89z"
  />
);

const textClass = createStyle('text', {
  fill: colors.white,
  fontFamily: fonts.nunito,
  fontSize: 48,
  textAnchor: 'end',
});

export const WASDToMove = (
  <text className={textClass}>
    WASD to move
  </text>
);
